import React, { useState } from "react";
import { ClipLoader } from "react-spinners";

const GenerateBillSummary = ({
  handleSubmit,
  onClose,
  billingDate,
  sendInvoiceOption,
  loading,
  numberOfUnit,
  buildings,
}) => {
  const [options, setOptions] = useState(sendInvoiceOption);

  // all buildings
  console.log(buildings);

  switch (options) {
    case "MONTHLY":
      setOptions("Monthly");
      break;
    case "BI_MONTHLY":
      setOptions("Bi-monthly");
      break;
    case "NO_INVOICE":
      setOptions("No Invoice");
      break;
    default:
      console.log("");
  }

  const lastBillDates = buildings.map(
    (a) => a.lastBillGeneratedDate?.split("T")[0] || null
  );

  const lastInvoiceDates = buildings.map(
    (a) => a.lastInvoiceDate?.split("T")[0] || null
  );

  const allSame = (arr) => arr.every((date) => date === arr[0]);

  const allBillDatesSame = allSame(lastBillDates);
  const allInvoiceDatesSame = allSame(lastInvoiceDates);

  const displayBillDate = allBillDatesSame
    ? lastBillDates[0] || "-"
    : "Last bill dates are not the same for all buildings";

  const displayInvoiceDate = allInvoiceDatesSame
    ? lastInvoiceDates[0] || "-"
    : "Last invoice dates are not the same for all buildings";

  return (
    <div>
      <h2 className="mb-3 text-center ">
        Bill summary for building {numberOfUnit}
      </h2>
      <div className="flex items-center mb-2 justify-between ">
        <p className="mr-1"> Billing Date: </p>
        <p>{billingDate} </p>
      </div>
      <div className="flex items-center mb-2 justify-between ">
        <p className="mr-1">Generate Invoice: </p>
        <p>{options} </p>
      </div>
      <div className="flex items-center mb-2 justify-between ">
        <p className="mr-1"> Last Bill Date: </p>
        <p className={`text-[14px] ${!allBillDatesSame ? "text-red-500" : ""}`}>
          {displayBillDate}
        </p>
      </div>
      <div className="flex items-center mb-2 justify-between ">
        <p className="mr-1"> Last Invoice Date: </p>
        <p
          className={`text-[14px] ${
            !allInvoiceDatesSame ? "text-red-500" : ""
          }`}
        >
          {displayInvoiceDate}
        </p>
      </div>
      <div className="flex w-full mt-4 justify-between items-center">
        <button
          className="px-4 py-3 hover:text-white border-[#0054bb] border block bg-[#fff] text-[12px]  w-[47%] text-[#000] rounded hover:bg-[#0074bb]"
          onClick={onClose}
        >
          Cancel
        </button>
        <button
          className="px-4 block bg-[#0074bb] w-[47%] text-[12px] py-3 text-[#fff] rounded"
          onClick={handleSubmit}
        >
          {loading ? <ClipLoader size={20} color="#fff" /> : "Generate Bill"}
        </button>
      </div>
    </div>
  );
};

export default GenerateBillSummary;
